import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import GerenciarUsuarios from "../views/usuario/GerenciarUsuarios.vue";
import GerenciarPessoas from "../views/pessoa/GerenciarPessoas.vue";
import Perfil from "../views/usuario/Perfil.vue";
import GerenciarArquivosUsuarios from "../views/arquivosUsuarios/GerenciarArquivosUsuarios.vue";
import Arquivos from "../views/arquivosUsuarios/Arquivos.vue";
import GerenciarArquivosPrimeseg from "../views/arquivosPrimeseg/GerenciarArquivosPrimeseg.vue";
import AgendamentoCliente from "../views/agendamento/AgendamentoCliente.vue";
import GerenciarAgendamentos from "../views/agendamento/GerenciarAgendamentos.vue";
import Chamado from "../views/agendamento/Chamado.vue";
import Cat from "../views/cat/Cat.vue";
import GerenciarCat from "../views/cat/GerenciarCat.vue";
import RedefinirSenhaViaEsqueciMinhaSenha from "../views/outros/RedefinirSenhaViaEsqueciMinhaSenha.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			component: Home,
			meta: { requiresAuth: true },
		},
		{
			path: "/login",
			name: "Login",
			component: Login,
		},
		{
			path: "/usuario/gerenciar-usuarios",
			name: "GerenciarUsuarios",
			component: GerenciarUsuarios,
			meta: { requiresAuth: true },
		},
		{
			path: "/pessoa/gerenciar-pessoas",
			name: "GerenciarPessoas",
			component: GerenciarPessoas,
			meta: { requiresAuth: true },
		},
		{
			path: "/usuario/perfil",
			name: "Perfil",
			component: Perfil,
			meta: { requiresAuth: true },
		},
		{
			path: "/arquivo/gerenciar-arquivos-usuarios",
			name: "GerenciarArquivosUsuarios",
			component: GerenciarArquivosUsuarios,
			meta: { requiresAuth: true },
		},
		{
			path: "/arquivo/arquivos",
			name: "Arquivos",
			component: Arquivos,
			meta: { requiresAuth: true },
		},
		{
			path: "/arquivo/gerenciar-arquivos-primeseg",
			name: "GerenciarArquivosPrimeseg",
			component: GerenciarArquivosPrimeseg,
			meta: { requiresAuth: true },
		},
		{
			path: "/agendamento/realizar-agendamento",
			name: "AgendamentoCliente",
			component: AgendamentoCliente,
			meta: { requiresAuth: true },
		},
		{
			path: "/agendamento/gerenciar-agendamentos",
			name: "GerenciarAgendamentos",
			component: GerenciarAgendamentos,
			meta: { requiresAuth: true },
		},
		{
			path: "/agendamento/chamado",
			name: "Chamado",
			component: Chamado,
			meta: { requiresAuth: true },
		},
		{
			path: "/cat/enviar-cat",
			name: "Cat",
			component: Cat,
			meta: { requiresAuth: true },
		},
		{
			path: "/cat/gerenciar-cat",
			name: "GerenciarCat",
			component: GerenciarCat,
			meta: { requiresAuth: true },
		},
		{
			path: "/redefinirSenha",
			name: "RedefinirSenhaViaEsqueciMinhaSenha",
			component: RedefinirSenhaViaEsqueciMinhaSenha,
			meta: { requiresAuth: false },
		},
	],
});



// WEBPACK FOOTER //
// ./src/router/index.js